import { render, staticRenderFns } from "./contactIntentionModel.vue?vue&type=template&id=406b2452&scoped=true&"
import script from "./contactIntentionModel.vue?vue&type=script&lang=js&"
export * from "./contactIntentionModel.vue?vue&type=script&lang=js&"
import style0 from "./contactIntentionModel.vue?vue&type=style&index=0&id=406b2452&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b2452",
  null
  
)

export default component.exports